import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Sirve si nunca estudié Reiki antes?',
  a: 'Sí. El Tomo 1 — El Despertar del Canal — está diseñado para empezar desde cero. No necesitás experiencia previa.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. En menos de 5 minutos después de tu compra recibís acceso completo a todos los tomos y bonos en PDF.'
}, {
  q: '¿El certificado es oficial?',
  a: 'Sí. El certificado de Academia Holística Argentina es internacional y está diseñado para enmarcarlo y mostrarlo en tu espacio de trabajo.'
}, {
  q: '¿Puedo usarlo para enseñar a otros?',
  a: 'Con el MegaPack podés practicar y certificarte. Con el Kit Reiki Profesional tenés todo el sistema para formar tus propios alumnos.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días sin preguntas. Si no es lo que esperabas te devolvemos el 100%. Sin formularios. Sin drama.'
}];
export function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-188">
      <div className="container mx-auto max-w-3xl" data-id="element-189">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-190">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-191">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-3" data-id="element-192">
          {FAQS.map((faq, idx) => <div key={idx} className="bg-[#111111] rounded-xl border border-white/10 overflow-hidden transition-all duration-300" data-id="element-193">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-194">
                <span className="font-bold text-white pr-4" data-id="element-195">{faq.q}</span>
                <span className={`text-[#eab308] text-xl transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`} data-id="element-196">
                  +
                </span>
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-197">
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-198">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}